import { render } from "./my-settings.vue?vue&type=template&id=2589e6e6&ts=true"
import script from "./my-settings.vue?vue&type=script&lang=ts"
export * from "./my-settings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__